<template>
  <div>
    <v-progress-linear v-if="loading" :indeterminate="true" :height="2"></v-progress-linear>
    <div v-html="content"/>
  </div>
</template>

<script>
export default {
  name: "StaticContent",
  components: {},
  data: () => ({
    loading: false,
    content: undefined
  }),
  props: {
    which: {
      type: String,
      required: true
    },
  },
  mounted: function() {
    this.loadContent();
  },
  methods: {
    loadContent() {
      this.loading = true
      this.$http
        .get("/api/static/content/" + encodeURIComponent(this.which))
        .then(res => {
          this.loading = false;
          this.content = res.data.content          
        })
        .catch(error => {
          this.loading = false;
          this.$common.onError(error)
        });
    }
  }
};
</script>

<style scoped>
</style>
